import { Button } from '@chakra-ui/react'
import { useTranslationsContext } from 'BrokerTsLib/src/context/TranslationsContext'

export const ExportButton = ({isExportOpen, setExportOpen}: {isExportOpen: boolean, setExportOpen: (open: boolean) => void}) => {
  const { translate } = useTranslationsContext()

  return (
    <Button onClick={() => setExportOpen(!isExportOpen)}>
      {isExportOpen ? translate('ui.hideExport', 'Skrýt export') : translate('ui.export', 'Export')}
    </Button>
  )
}